<template>
  <b-modal
    id="new-form-modal"
    ref="new-form-modal"
    centered
    title="Create New Form"
    ok-title="Save Changes"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @show="setModalData"
    @hidden="resetModal"
    @ok="create"
  >
    <b-overlay
      id="overlay-background"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <validation-observer
        ref="createNewFormRules"
        tag="form"
      >
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label="Name"
            >
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-input
                  v-model="name"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label="Type"
            >
              <validation-provider
                #default="{ errors }"
                name="Type"
                rules="required"
              >
                <v-select
                  v-model="type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="typesList"
                  :clearable="true"
                  :placeholder="'Select Type of Form'"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label="School"
            >
              <validation-provider
                #default="{ errors }"
                name="School"
              >
                <v-select
                  v-model="schoolId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="instancesList"
                  :clearable="true"
                  :placeholder="'Select School'"
                  label="name"
                  value="id"
                  :reduce="option => option.id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useFormsSetting from '@/views/admin/forms/useFormsSetting'
import axios from '@/libs/axios'

export default {
  name: 'NewFormModal',
  components: {
    ValidationProvider,
    ValidationObserver,

    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BOverlay,
    vSelect,
  },
  props: {
    folderId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      name: '',
      type: '',
      schoolId: '',
      instancesList: [],
      typesList: [
        {
          value: 'form',
          label: 'Registration Form',
        },
        {
          value: 'new-child-form',
          label: 'New Child Form',
        },
      ],
      required,
    }
  },
  setup() {
    const {
      postForm,
    } = useFormsSetting()

    return {
      postForm,
    }
  },
  methods: {
    async setModalData() {
      const response = await axios.get('/auth/schools')
      this.instancesList = response.data.data
    },
    resetModal() {
      this.name = ''
      this.type = ''
      this.schoolId = ''
    },
    create(bvModalEvt) {
      bvModalEvt.preventDefault()

      return new Promise(() => {
        this.$refs.createNewFormRules.validate().then(success => {
          if (success) {
            const queryParams = {
              name: this.name,
              type: this.type,
              schoolId: this.schoolId,
            }

            if (this.folderId) queryParams.folder_id = this.folderId

            this.postForm(queryParams).then(() => {
              this.$emit('refetchData')
              this.$bvModal.hide('new-form-modal')
            })
          }
        })
      })
    },
  },
}
</script>
